import classNames from 'classnames';
import React from 'react';

import CrossIcon from '../../icons/CrossIcon';
import styles from './styles.module.scss';

const CrossBtn = ({ onClick, nativeClassName, stroke }) => {
    return (
        <button onClick={onClick} className={classNames(styles.cross, !!nativeClassName && nativeClassName)}>
            <CrossIcon stroke={stroke} />
        </button>
    );
};

export default CrossBtn;
